<svg
  mib-icon
  name="search"
  aria-hidden="true"
  class="pointer-events-none absolute top-3 left-3 size-4 text-gray-500 dark:text-gray-300"></svg>
<ng-content select="input" />
@if (clearable()) {
  <button
    type="button"
    class="mib-field-action absolute top-1 right-1"
    [attr.aria-label]="clearLabel()"
    (pointerdown)="$event.preventDefault()"
    (click)="clear()">
    <svg mib-icon name="x" class="size-4"></svg>
  </button>
}
